import { type ButtonsAlign } from "@common/contexts/FormStyle";
import CancelButton from "@common/controls/Form/Buttons/Cancel";
import SubmitButton from "@common/controls/Form/Buttons/Submit";
import { FormButtons } from "@common/controls/Form/component";
import Modal from "@common/controls/Modal/component";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";

export type BecomeAffiliateModalProps = {
  buttonsAlign?: ButtonsAlign;
  containerSelector?: string;
  isVisible: boolean;
  onClose: () => void;
  onSubmit: () => void;
  text: any;
  maxHeight?: string | number | undefined;
  maxWidth?: string | number | undefined;
  width?: string | number | undefined;
};
export const BecomeAffiliateModal = ({ onSubmit, text, ...props }: BecomeAffiliateModalProps) => {
  const i18n = useI18n();
  return (
    <Modal {...props}>
      <Modal.Header title={i18n.becomeAnAffiliate} />
      <Modal.Body>
        {typeof text === "string" ? (
          <div
            dangerouslySetInnerHTML={{
              __html: text
            }}
          />
        ) : (
          text
        )}
        <FormButtons align={props.buttonsAlign}>
          <CancelButton onClick={props.onClose} />
          <SubmitButton onClick={onSubmit}>{i18n.becomeAnAffiliate}</SubmitButton>
        </FormButtons>
      </Modal.Body>
    </Modal>
  );
};
